import queryString from "query-string";
import { Settings } from "./settings";
const defaultSettings = new Settings({});
export const updateSettingsToUrlHash = (settings) => {
    let params = {
        year: settings.getYear(),
        zoom: settings.getZoom(),
        mapCenter: settings.getMapCenter(),
    };
    if (defaultSettings.getBackgroundMap() !== settings.getBackgroundMap()) {
        params = { ...params, backgroundMap: settings.getBackgroundMap() };
    }
    if (defaultSettings.getLayerOpacity() !== settings.getLayerOpacity()) {
        params = { ...params, opacity: settings.getLayerOpacity() };
    }
    window.location.hash = `#${queryString.stringify(params, {
        arrayFormat: "comma",
    })}`;
};
export const parseSettingsFromUrlHash = () => {
    const { year, backgroundMap, zoom, mapCenter, opacity } = queryString.parse(window.location.hash, {
        parseNumbers: true,
        arrayFormat: "comma",
    });
    let settings = {};
    if (year !== undefined && typeof year === "number") {
        settings = { ...settings, year };
    }
    if (backgroundMap !== undefined && typeof backgroundMap === "string") {
        settings = { ...settings, backgroundMap };
    }
    if (zoom !== undefined && typeof zoom === "number") {
        settings = { ...settings, zoom };
    }
    if (mapCenter &&
        Array.isArray(mapCenter) &&
        mapCenter.every((v) => typeof v === "number")) {
        settings = { ...settings, mapCenter };
    }
    if (opacity !== undefined && typeof opacity === "number") {
        settings = { ...settings, opacity };
    }
    return settings;
};
